import moment from 'moment';

import { getAllNumbersByMonthForCareerProgression } from '@/js/store/calculator/utilities/allNumbersHelpers';

export { getCareerService } from '@/js/store/calculator/utilities/careerProgressionHelpers';

/**
 * Get rank override list for Hi3 past years based on current rank and year of service.
 */
export function getOverrideRanksForHi3PastYears(rank) {
  const ranks = {
    // Enlisted ranks
    'E-1': ['E-1'],
    'E-2': ['E-1', 'E-2'],
    'E-3': ['E-1', 'E-2', 'E-3'],
    'E-4': ['E-2', 'E-3', 'E-4'],
    'E-5': ['E-3', 'E-4', 'E-5'],
    'E-6': ['E-5', 'E-6'],
    'E-7': ['E-6', 'E-7'],
    'E-8': ['E-7', 'E-8'],
    'E-9': ['E-8', 'E-9'],

    // Warrant Officer ranks
    'W-1': ['W-1', 'E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9'],
    'W-2': ['W-2', 'W-1', 'E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9'],
    'W-3': ['W-3', 'W-2', 'E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9'],
    'W-4': ['W-4', 'W-3', 'W-2', 'E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9'],
    'W-5': ['W-5', 'W-4', 'W-3', 'E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9'],

    // Officer ranks
    'O-1': ['O-1'],
    'O-2': ['O-1', 'O-2'],
    'O-3': ['O-1', 'O-2', 'O-3'],
    'O-4': ['O-3', 'O-3E', 'O-4'],
    'O-5': ['O-4', 'O-5'],
    'O-6': ['O-5', 'O-6'],
    'O-7': ['O-6', 'O-7'],
    'O-8': ['O-6', 'O-7', 'O-8'],
    'O-9': ['O-6', 'O-7', 'O-8', 'O-9'],
    'O-10': ['O-6', 'O-7', 'O-8', 'O-9', 'O-10'],

    // Prior Enlisted ranks
    'O-1E': ['O-1E', 'E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9', 'W-1', 'W-2', 'W-3', 'W-4', 'W-5'],
    'O-2E': ['O-1E', 'O-2E'],
    'O-3E': ['O-2E', 'O-3E'],
  };

  return ranks[rank] || [];
}

/**
 * The Hi3 Pension requires 36 months of data to compute. If the service member's number of
 * of months remaining in the service before ret/sep, need to request 'pasy years' data from prior calendar
 * years to obtain 36 months.
 */
export function getHi3PastYears(serviceMember) {
  const hi3PastYears = [];

  if (serviceMember.isEligibleForRetirementPension() && serviceMember.numberOfMonthsRemainingInServiceCareer() < 36) {
    const { currentRank } = serviceMember;
    const rundate = serviceMember.rundate();

    const allNumbersByMonth = getAllNumbersByMonthForCareerProgression(serviceMember);

    const startingDate = moment(rundate).subtract(36 - serviceMember.numberOfMonthsRemainingInServiceCareer(), 'months');
    const endingDate = moment(rundate).subtract(1, 'months');
    const startingYearOfService = allNumbersByMonth.find((o) => o.calendarYear === startingDate.year() && o.calendarMonth === startingDate.month() + 1).pebdServiceYear;
    const endingYearOfService = allNumbersByMonth.find((o) => o.calendarYear === endingDate.year() && o.calendarMonth === endingDate.month() + 1).pebdServiceYear;

    for (let serviceYear = startingYearOfService; serviceYear <= endingYearOfService; serviceYear += 1) {
      const obj = allNumbersByMonth.find((o) => o.pebdServiceYear === serviceYear);
      hi3PastYears.push({
        yearOfService: obj.pebdServiceYear,
        age: obj.ageYears,
        calendarYear: obj.calendarYear,
        defaultOverrideRank: currentRank,
        overrideRanks: getOverrideRanksForHi3PastYears(currentRank),
        suggestedRank: currentRank,
        yearOfServiceRank: currentRank,
      });
    }
  }

  return hi3PastYears;
}
